export default "__VITE_ASSET__d3904ce0__"